/* eslint-disable react-hooks/exhaustive-deps */
import {useContext, useState, useEffect, useMemo} from 'react'
import {useQuery} from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  initialQueryState,
} from '../../../../../../_metronic/helpers'
import {getUsers} from '../../../user-management/users-list/core/_requests'
import {useQueryRequest} from './QueryRequestProvider'
import {toast} from 'react-toastify'
import {useNavigate} from 'react-router-dom'

const QueryResponseContext = createResponseContext(initialQueryResponse)
const QueryResponseProvider = ({children}) => {
  const navigate = useNavigate()
  const {state} = useQueryRequest()
  const [query, setQuery] = useState(state)
  const updatedQuery = useMemo(() => state, [state])
  const [filterUsers, setFilterUsers] = useState([
    {
      id: 1,
      name: 'Samir Məmmədov',
      position: 'Müdür',
      family: 'İnsan Resursları',
      risk: 'Bəli',
      planStatus: 'Qırmızı',
      testimonial: 'free text',
      temp: 'Kərim Kərimov',
      zerotwelve: 'Kərim Kərimov',
      onetwelve: 'Kərim Kərimov',
      twofour: 'Kərim Kərimov',
      leader: 'Rehber',
      status: 'N-3',
    },
    {
      id: 2,
      name: 'Cavad Manafov',
      position: 'Müdür',
      family: 'İnsan Resursları',
      risk: 'Xeyr',
      planStatus: 'Narıncı',
      testimonial: 'free text',
      temp: 'Kərim Kərimov',
      zerotwelve: 'Kərim Kərimov',
      onetwelve: 'Kərim Kərimov',
      twofour: 'Kərim Kərimov',
      leader: 'Rehber',
      status: 'N-3',
    },
    {
      id: 3,
      name: 'Səlim Səlimov',
      position: 'Müdür',
      family: 'İnsan Resursları',
      risk: 'Bəli',
      planStatus: 'Yaşıl',
      testimonial: 'free text',
      temp: 'Kərim Kərimov',
      zerotwelve: 'Kərim Kərimov',
      onetwelve: 'Kərim Kərimov',
      twofour: 'Kərim Kərimov',
      leader: 'Rehber',
      status: 'N-3',
    },
  ])

  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery)
    }
  }, [updatedQuery])

  const {isFetching, refetch, data} = useQuery(
    'users',
    // async () => {
    //   try {
    //     const result = await getUsers(query);

    //     if (result.status === 200) {
    //       setFilterUsers(result.data);
    //       return result.data;
    //     } else if (result?.response?.status === 401) {
    //       localStorage.removeItem('token');
    //       navigate('/auth/login');

    //     } else {

    //       throw new Error(result?.response?.data?.message)
    //     }
    //   } catch (error) {

    //     toast.error(error?.message, {
    //       autoClose: 10000
    //     });

    //     return error.message
    //   }
    // },

    {
      cacheTime: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      // onSuccess: (data) => setFilterUsers(data),
    }
  )

  const searchByUsernName = (searchText) => {
    setFilterUsers(
      [...data].filter((user) => {
        if (user.username.toLowerCase().includes(searchText.toLowerCase())) {
          return user
        }
        return false
      })
    )
  }

  return (
    <QueryResponseContext.Provider
      value={{isLoading: false, refetch, filterUsers, searchByUsernName, query}}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

const useQueryResponse = () => useContext(QueryResponseContext)

const useQueryResponseData = () => {
  const {filterUsers} = useQueryResponse()

  if (filterUsers.length === 0) {
    return []
  }

  return filterUsers || []
}

const useQueryResponsePagination = () => {
  const defaultPaginationState = {
    links: [],
    ...initialQueryState,
  }

  const {response} = useQueryResponse()
  if (!response || !response.payload || !response.payload.pagination) {
    return defaultPaginationState
  }

  return response.payload.pagination
}

const useQueryResponseLoading = () => {
  const {isLoading} = useQueryResponse()
  return isLoading
}

export {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponsePagination,
  useQueryResponseLoading,
}
